export const LockIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15.9096 10.1333H15.4146V7.8C15.4146 7.05739 15.1018 6.3452 14.5448 5.8201C13.9879 5.295 13.2325 5 12.4449 5C11.6573 5 10.902 5.295 10.345 5.8201C9.78811 6.3452 9.47524 7.05739 9.47524 7.8V10.1333H8.98029C8.45539 10.1339 7.95215 10.3307 7.58099 10.6807C7.20983 11.0306 7.00106 11.5051 7.00049 12V17.1333C7.00106 17.6282 7.20983 18.1027 7.58099 18.4527C7.95215 18.8026 8.45539 18.9995 8.98029 19H15.9096C16.4345 18.9995 16.9377 18.8026 17.3089 18.4527C17.68 18.1027 17.8888 17.6282 17.8894 17.1333V12C17.8888 11.5051 17.68 11.0306 17.3089 10.6807C16.9377 10.3307 16.4345 10.1339 15.9096 10.1333ZM14.4247 10.1333H10.4651V7.8C10.4651 7.30493 10.6737 6.83014 11.045 6.48007C11.4163 6.13 11.9199 5.93333 12.4449 5.93333C12.97 5.93333 13.4736 6.13 13.8449 6.48007C14.2161 6.83014 14.4247 7.30493 14.4247 7.8V10.1333Z"
        fill="#B8B9C1"
      />
    </svg>
  );
};
